<div mat-dialog-title class="dialog-title">{{title}}</div>
<mat-dialog-content>
    <ng-container *ngIf="!containsHTML">{{message}}</ng-container>
    <ng-container *ngIf="containsHTML">
        <span [innerHTML]="message | safeHtml"></span>
    </ng-container>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-raised-button class="button ok-button" tabindex="0" (click)="okClicked()">OK</button>
</mat-dialog-actions>